/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Thumbnail_Already_In_Folder_ToastInputs */

const en_explorer_thumbnail_already_in_folder_toast = /** @type {(inputs: Explorer_Thumbnail_Already_In_Folder_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some items are already in this folder`)
};

const fr_explorer_thumbnail_already_in_folder_toast = /** @type {(inputs: Explorer_Thumbnail_Already_In_Folder_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certains elements sont deja dans ce dossier`)
};

const de_explorer_thumbnail_already_in_folder_toast = /** @type {(inputs: Explorer_Thumbnail_Already_In_Folder_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einige Elemente befinden sich bereits in diesem Ordner`)
};

const it_explorer_thumbnail_already_in_folder_toast = /** @type {(inputs: Explorer_Thumbnail_Already_In_Folder_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alcuni elementi sono già presenti in questa cartella`)
};

const ru_explorer_thumbnail_already_in_folder_toast = /** @type {(inputs: Explorer_Thumbnail_Already_In_Folder_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Некоторые элементы уже находятся в этой папке.`)
};

const es_explorer_thumbnail_already_in_folder_toast = /** @type {(inputs: Explorer_Thumbnail_Already_In_Folder_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algunos elementos ya están en esta carpeta`)
};

const zh_cn2_explorer_thumbnail_already_in_folder_toast = /** @type {(inputs: Explorer_Thumbnail_Already_In_Folder_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此文件夹中已有一些项目。`)
};

const ja_explorer_thumbnail_already_in_folder_toast = /** @type {(inputs: Explorer_Thumbnail_Already_In_Folder_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このフォルダには既にいくつかのアイテムが入っています`)
};

const hi_explorer_thumbnail_already_in_folder_toast = /** @type {(inputs: Explorer_Thumbnail_Already_In_Folder_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस फोल्डर में पहले से ही कुछ आइटम मौजूद हैं।`)
};

const pt_pt2_explorer_thumbnail_already_in_folder_toast = /** @type {(inputs: Explorer_Thumbnail_Already_In_Folder_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alguns itens já estão nesta pasta.`)
};

/**
* | output |
* | --- |
* | "Some items are already in this folder" |
*
* @param {Explorer_Thumbnail_Already_In_Folder_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_thumbnail_already_in_folder_toast = /** @type {((inputs?: Explorer_Thumbnail_Already_In_Folder_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Thumbnail_Already_In_Folder_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_thumbnail_already_in_folder_toast(inputs)
	if (locale === "de") return de_explorer_thumbnail_already_in_folder_toast(inputs)
	if (locale === "it") return it_explorer_thumbnail_already_in_folder_toast(inputs)
	if (locale === "ru") return ru_explorer_thumbnail_already_in_folder_toast(inputs)
	if (locale === "es") return es_explorer_thumbnail_already_in_folder_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_thumbnail_already_in_folder_toast(inputs)
	if (locale === "ja") return ja_explorer_thumbnail_already_in_folder_toast(inputs)
	if (locale === "hi") return hi_explorer_thumbnail_already_in_folder_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_thumbnail_already_in_folder_toast(inputs)
	return en_explorer_thumbnail_already_in_folder_toast(inputs)
});